<!--选择仓库-->
<template>
  <el-dialog title="仓库选择"
             :visible.sync="dialogFormVisible"
             :custom-class="dialogClass"
             center
             :close-on-click-modal="false"
             :append-to-body="true" @close="afterCloseDialog">
    <el-form :model="form" ref="form1" :rules="rules">
      <p v-show="uname"><span>操作人：</span>{{uname}}<span>正在操作</span><span @click="unlock" style="color: blue;cursor: pointer;">&nbsp;解除锁定</span></p>
      <el-form-item label="客户名称：" :label-width="formLabelWidth">
        <!--{{controlData.customerserial}}-->
        <!--<span>客户名称：</span>-->
        {{controlData.customername}}
      </el-form-item>
      <el-form-item label="发货仓库：" :label-width="formLabelWidth" :required="true">
        <el-select v-model="form.cangkucode" placeholder="请选择" @change="changecangku" style="width: 140px">
          <el-option
            v-for="item in jxcstoreData" v-if="!item.counter||item.counter!=1"
            :key="item.cangkucode"
            :label="item.cangkuname"
            :value="item.cangkucode">
          </el-option>
        </el-select>
        <span style="padding-left: 30px;color: red" v-if="needbuystore>0">缺货：{{needbuystore}}</span>
        <span>供应商单号：</span>
        <el-input v-model="form.tracknum" placeholder="请填写供应商单号" onfocus="this.select()" style="width: 140px"></el-input>
        <span style="color:red;font-weight:bold;" v-if="controlData.isjiaji==1">加急</span><span style="color:red;font-weight:bold; " v-if="controlData.isjiaji==1">期望时间：</span>{{controlData.wantarrivaltime}}
      </el-form-item>
      <el-form-item label="" label-width="0" v-if="!isjiagong">
        <el-table
          :data="tableData" v-if="BindOver&&intelligentstore"
          :height="tableHeight(182)"
          size="mini"
          border :row-class-name="tableRowClassName"
          style="width: 100%;">
          <el-table-column label="R/L" align="center" header-align="center" width="50">
            <template slot-scope="scope">
              {{ getRL(scope.row.formproperty) }}
            </template>
          </el-table-column>
          <el-table-column label="产品编码" align="left" header-align="center" :show-overflow-tooltip="true" width="100">
            <template slot-scope="scope">
              {{ scope.row.seedcode }}
            </template>
          </el-table-column>
          <el-table-column label="产品名称" align="left" header-align="center" width="200" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              {{ scope.row.seedname }}
            </template>
          </el-table-column>
          <el-table-column label="规格" align="left" header-align="center" width="130">
            <template slot-scope="scope">
              <div style="white-space:nowrap;text-overflow:ellipsis;overflow:hidden;width: 96%;height:24px;" :title="scope.row.newpackagesize">{{ scope.row.newpackagesize }}</div>
            </template>
          </el-table-column>
          <el-table-column label="参数" align="center" header-align="center" width="80">
            <template slot-scope="scope">
              {{ getParam(scope.row.formproperty) }}
            </template>
          </el-table-column>
          <el-table-column label="订单数量" align="right" header-align="center" width="70">
            <template slot-scope="scope">
              {{scope.row.totalnumber}}
            </template>
          </el-table-column>
          <el-table-column label="库存" align="right" header-align="center" width="70">
            <template slot-scope="scope">
              {{scope.row.subtractnum}}
            </template>
          </el-table-column>
          <el-table-column label="待发货" align="right" header-align="center" width="70">
            <template slot-scope="scope">
              {{scope.row.deliverying}}
            </template>
          </el-table-column>
          <el-table-column label="调拨中" align="right" header-align="center" width="70">
            <template slot-scope="scope">
              {{scope.row.transfernum}}
            </template>
          </el-table-column>
          <el-table-column label="可用库存" align="right" header-align="center" width="70">
            <template slot-scope="scope">
              {{scope.row.canuse}}
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false;afterCloseDialog()">取 消</el-button>
      <el-button type="primary" class="qrbtn" @click="updatecangku" :loading="isDisable" v-if="!uname">确认</el-button>
    </div>
  </el-dialog>
</template>
<script>
  import {updatecangku, getJxcformdetailGetList, saveCstagreementData} from '@/api/set/csagreement';
  import {getGoodsListWithStoreDetail} from '@/api/set/jxcresultstore';
  import {cusandptbyind} from '@/api/set/jxcstore';
  import {saveData, getListData, lockremove} from '@/api/set/handlelog';
  import {simulationLogin, checkModuleRight} from '@/api/login'
  import {
    updatejiagong,
  } from '@/api/set/csagreement';
  import {
    jxcstorelist
  } from '@/api/set/csagreement';

  export default {
    inject: ["afterCloseDialog"],
    name: "DataContactEdit",
    data() {
      return {
        isDisable: false,//控制多次提交
        caozuoname: '',
        needbuystore: 0,
        dialogFormVisible: false,
        intelligentstore: true,
        dialogClass: '',
        showtitle: '',
        BindOver: true,
        jxcstoreData: [],
        hd_status: null,
        unitguid: '',
        erpserial: "",
        groupguid:"",
        status: "",
        pcustomerserial: '',
        isjiagong: '',
        tableData: [],
        controlData: [],
        bn: '',
        form: {
          cangkucode: null,
          cangkuname: null,
          tracknum: '',
        },
        issimpleupdate: 0,
        formLabelWidth: '120px',
        rules: {////////定义正则验证字段。
          cangkucode: [
            {required: true, message: '请选择仓库', trigger: 'change'},
          ],
        },
        lock: false,//锁定订单
        uname: '',//正在操作的人
        userInfoModel: {},//当前缓存
      }
    },
    methods: {
      getParam(formpro) {
        var val = '';
        if (formpro) {
          try {
            var json = JSON.parse(formpro)[0];
            if (json.ADD) {
              val += 'ADD:' + json.ADD;
            }
            if (json['通道']) {
              val += '  通道:' + json['通道'];
            }
          } catch (e) {

          }
        }
        return val;
      },
      getRL(formpro) {
        if (formpro) {
          try {
            var json = JSON.parse(formpro)[0].type;
            if (json)
              return json;
          } catch (e) {

          }
        }
        return '';
      },
      //解除锁定
      unlock() {
        var casestepname = ''
        if (this.isjiagong) {
          casestepname = '操作通知加工';
        } else {
          casestepname = '操作通知仓库';
        }
        lockremove({
          erpserial: this.erpserial
        }).then(response => {
          if (response.data.code == 0) {
            this.lock = true
            this.uname = ''
            //锁定功能(控制发起采购按钮)
            this.handlelog(casestepname);
          } else {
            this.$message({
              message: response.data.msg,
              type: 'error'
            })

          }
        })
      },
      //处理日志
      handlelog(casestepname) {
        var handlelog = {}
        handlelog.erpserial = this.erpserial
        handlelog.isopen = 1
        handlelog.groupguid=this.groupguid
        if (!casestepname) {
          if (this.isjiagong) {
            handlelog.casestepname = '通知加工'
            handlelog.remark = '通知' + this.form.cangkuname + '加工'
          } else if (this.issimpleupdate == 1) {

          } else if (this.status == '650') {
            handlelog.casestepname = '等待仓库收货'
            handlelog.remark = '等待仓库收货'
          } else {
            handlelog.casestepname = '通知仓库'
            handlelog.remark = '通知' + this.form.cangkuname + '发货'
          }
        } else {//锁定功能进这里
          handlelog.isopen = 0
          handlelog.casestepname = casestepname
        }
        saveData(handlelog).then(response => {
        })
      },
      tableRowClassName({row, rowIndex}) {
        if (row.canuse < row.totalnumber) {
          return 'danger-row';
        }
        return '';
      },
      updatecangku() {
        this.isDisable = true//防止多次提交
        // if (JSON.parse(localStorage.getItem("hpapi_parames")).other.oddrequired == 'true') {
        //   if (!this.form.tracknum) {
        //     this.$message({
        //       message: '请输入供应商单号',
        //       type: 'error'
        //     })
        //     this.isDisable = false
        //     return
        //   }
        // }

        if (this.form.cangkucode) {
          this.$refs.form1.validate((valid) => {
            if (valid) {
              if (this.isjiagong) {//修改供应商仓库的时候使用;通知加工
                updatejiagong({
                  unitguid: this.unitguid,
                  cangkucode: this.form.cangkucode,
                  cangkuname: this.form.cangkuname,
                  status: 300,
                  tracknum: this.form.tracknum.trim(),
                  invoicesource: 1
                }).then(response => {
                  if (response.data.code == 0) {
                    this.$message({
                      message: '保存成功',
                      type: 'success'
                    })
                    this.handlelog();
                    this.$emit('bindGrid');
                    this.$emit('print');
                    this.dialogFormVisible = false;

                  } else {
                    this.$message({
                      message: response.data.msg,
                      type: 'error'
                    })
                    this.isDisable = false
                  }
                })
              } else if (this.issimpleupdate == 1) {//修改仓库的时候使用
                saveCstagreementData({
                  unitguid: this.unitguid,
                  cangkucode: this.form.cangkucode,
                  cangkuname: this.form.cangkuname
                }).then(response => {
                  if (response.data.code == 0) {
                    this.$message({
                      message: '保存成功',
                      type: 'success'
                    })
                    this.dialogFormVisible = false;
                    this.$emit('afertupdatecangku', this.form.cangkucode, this.form.cangkuname);
                  } else {
                    this.$message({
                      message: response.data.msg,
                      type: 'error'
                    })
                    this.isDisable = false
                  }
                })

              } else {
                updatecangku({
                  erpserial: this.erpserial,
                  unitguid: this.unitguid,
                  cangkucode: this.form.cangkucode,
                  cangkuname: this.form.cangkuname,
                  tracknum: this.form.tracknum.trim(),
                  status: this.status,
                  pcustomerserial: this.pcustomerserial,
                  invoicesource: this.bn,
                }).then(response => {
                  if (response.data.code == 0) {
                    this.$message({
                      message: '保存成功',
                      type: 'success'
                    })
                    this.handlelog();
                    this.$emit('bindGrid');
                    this.$emit('print');
                    this.dialogFormVisible = false;
                  } else {
                    this.$message({
                      message: response.data.msg,
                      type: 'error'
                    })
                    this.isDisable = false
                  }
                })
              }
            }
          })
        } else {
          this.$message({
            message: "请选择仓库",
            type: 'error'
          })
          this.isDisable = false
        }

      },

      initData(item, isjiagong, dialogCl, issimpleupdate) {
        var obj = this
        this.initForm()
        if (item.biaoji == "store") {
          this.bn = 2
        }
        this.dialogClass = (dialogCl || 'mini-dialog');
        this.unitguid = item.unitguid
        this.erpserial = item.erpserial
        this.pcustomerserial = item.pcustomerserial
        this.status = item.status
        this.groupguid=item.groupguid
        this.dialogFormVisible = true;
        this.issimpleupdate = issimpleupdate
        if (isjiagong && isjiagong == 1) {
          this.isjiagong = true
        } else {
          this.isjiagong = false
        }
        cusandptbyind().then(response => {
          this.jxcstoreData = response.data.obj
          if (this.jxcstoreData && this.jxcstoreData.length > 0) {
            if (item.cangkucode && item.cangkuname) {
              for (let i in this.jxcstoreData) {
                if (this.jxcstoreData[i].cangkucode == item.cangkucode) {
                  this.form.cangkucode = item.cangkucode;
                  this.form.cangkuname = item.cangkuname;
                  break
                }
              }
            }
            if (!this.form.cangkucode) {
              this.form.cangkucode = this.jxcstoreData[0].cangkucode;
              this.form.cangkuname = this.jxcstoreData[0].cangkuname;
            }
            //////////////////////////////

            if (this.isjiagong || !this.intelligentstore || this.dialogClass == 'mini-dialog') {
              this.BindOver = false;
              return;
            }
            //////////////取订单明细///////////////
            getJxcformdetailGetList({
              erpserial: this.erpserial,
            }).then(resOrder => {
              this.tableData = resOrder.data.obj;
              this.controlData = resOrder.data.cstagreementDO;
              this.bindStore();
            });
          }
        })

        if (this.status != 200) {
          this.lock = true;
          return;
        }
        //查询订单是否有人正在操作
        getListData({
          erpserial: this.erpserial,
        }).then(response => {
          this.lock = true;
          if (response.data.obj.length > 0) {
            //发起采购、通知仓库按钮会同时出现，只要有一个在操作需要锁定订单
            //当前登陆人与日志表uname不一致时锁定采购订单
            for (let i = 0; i < response.data.obj.length; i++) {
              if (response.data.obj[i].casestepname == '操作通知仓库' || response.data.obj[i].casestepname == '申请采购' || response.data.obj[i].casestepname == '操作通知加工') {
                this.lock = false;
                if (response.data.obj[i].uname && this.userInfoModel.uname != response.data.obj[i].uname) {
                  this.uname = response.data.obj[i].uname;
                  break;
                }
              }
            }
          }
          if (this.lock) {
            //锁定功能(控制发起采购按钮)
            if (isjiagong && isjiagong == 1) {
              this.handlelog('操作通知加工');
            } else if (isjiagong && isjiagong == -1) {
              this.handlelog('操作通知仓库');
            }
          }
        })
      },
      bindStore() {
        let yearnow = new Date().getFullYear()
        let monthnow = new Date().getMonth() + 1
        // var SeedCodes = ';';
        for (let i in this.tableData) {
          this.tableData[i].subtractnum = 0;
          this.tableData[i].deliverying = 0;
          this.tableData[i].transfernum = 0;
          this.tableData[i].canuse = 0;
        }
        this.needbuystore = 0;
        this.BindOver = false;
        var GetCount = 0;
        for (let i in this.tableData) {
          var SeedCodes = ';';
          // if (SeedCodes.indexOf(';' + this.tableData[i]['seedcode'] + ';') == -1) {
          SeedCodes += this.tableData[i]['seedcode'] + ';';
          GetCount += 1;
          getGoodsListWithStoreDetail({
            seedcode: this.tableData[i]['seedcode'],//产品分类（单选）
            cangkucode: this.form.cangkucode,//选择的仓库（单选）
            minyear: yearnow,
            minmonth: monthnow,
            maxyear: yearnow,
            maxmonth: monthnow,
            nostock: 1,
          }).then(resStore => {
            var storeData = resStore.data.obj
            // for (let orderIndex in this.tableData) {
            var orderRow = this.tableData[i];
            var needBuyS = orderRow.totalnumber;
            for (let storeIndex in storeData) {
              var storeRow = storeData[storeIndex];
              if (orderRow.seedcode == resStore.data.seedcode && (orderRow.packagesize == undefined || orderRow.packagesize == storeRow.packagesize)) {
                orderRow.subtractnum = storeRow.subtractnum;
                orderRow.deliverying = storeRow.deliverying;
                orderRow.transfernum = storeRow.transfernum;
                orderRow.canuse = storeRow.subtractnum - storeRow.deliverying + storeRow.transfernum;//库存数量
                if (orderRow.canuse < orderRow.totalnumber) {//订单需要的数量 操过 库存数量
                  needBuyS = orderRow.totalnumber - (orderRow.canuse > 0 ? orderRow.canuse : 0);//需要补货的数量
                } else {
                  needBuyS = 0;
                  storeRow.subtractnum = storeRow.subtractnum - orderRow.totalnumber;//需要扣掉已使用的
                }
                break;
              }
            }
            this.needbuystore += needBuyS;
            this.tableData[i] = orderRow;
            // }
            GetCount -= 1;
            if (GetCount == 0)
              this.BindOver = true;
          }).catch((error) => {
            console.log(error)
          });
          // }
        }
      },
      changecangku(val) {
        for (let i in this.jxcstoreData) {
          if (this.jxcstoreData[i].cangkucode == val) {
            this.form.cangkuname = this.jxcstoreData[i].cangkuname;
          }
        }
        if (this.intelligentstore)
          this.bindStore();
      },
      initForm() {
        this.form.tracknum = ''
        this.tableData = []
        this.form.cangkucode = null
        this.form.cangkuname = null
        this.dialogClass = 'mini-dialog';
        this.erpserial = ""
        this.caozuoname = ''
        this.form.unitguid = ""
        if (this.$refs.form1 != undefined) {
          this.$refs.form1.resetFields();
        }
        this.uname = ''
        this.issimpleupdate = 0
        this.isjiagong = false;
        this.isDisable = false
      }
    },
    mounted() {
      this.userInfoModel = JSON.parse(localStorage.getItem("hpapi_userInfoModel"))
      checkModuleRight({name: 'intelligentstore'}).then(reponse => {
        this.intelligentstore = reponse.data.code == 0;
      });
    },
    components: {}
  }
</script>


<style scoped>
  .Hid {
    display: none;
  }

  .ddinfo {
    border-collapse: collapse;
    width: 100%;
    margin-top: 12px;

  }

  .ddinfo td {
    font-size: 14px;
    text-align: center;
    border: 1px solid #E0DFDF;
  }
</style>

<style>
  .el-table .danger-row {
    background: #F56C6C;
  }
</style>




// WEBPACK FOOTER //
// src/components/testorder/cstagreement/StoreEdit.vue